import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.499 12v8.445c0 .246-.2.445-.444.445h-8.001v-6.667c0-.246-.2-.445-.444-.445H7.054c-.246 0-.445.2-.445.445v6.667H4.831a.445.445 0 0 1-.444-.445v-8.444h.15c.65 0 1.245-.318 1.614-.823.01.01.016.022.023.034.382.5.962.789 1.593.789h.56a2 2 0 0 0 1.636-.85c.029.036.058.074.089.11a2.22 2.22 0 0 0 1.655.74h.471a2.22 2.22 0 0 0 1.656-.74c.031-.036.06-.074.089-.11a2 2 0 0 0 1.636.85h.56c.63 0 1.21-.29 1.593-.79.007-.01.014-.024.022-.033.37.505.965.822 1.614.822h.15Zm-2.222 5.779v-3.556c0-.246-.2-.445-.445-.445h-3.111c-.246 0-.445.2-.445.445v3.556c0 .245.2.444.445.444h3.111a.445.445 0 0 0 .445-.444ZM6.142 4a.889.889 0 0 0-.812.528L3.098 9.549c-.161.364-.122.763.107 1.089.215.306.58.474.954.474h.379c.498 0 .938-.336 1.071-.814L6.64 6.59 7.358 4H6.141ZM8.28 4 6.696 9.703a1.11 1.11 0 0 0 1.071 1.409h.56a1.11 1.11 0 0 0 1.105-.99L10.114 4H8.28Zm4.599 0h-1.872l-.627 5.631a1.34 1.34 0 0 0 1.327 1.48h.471a1.34 1.34 0 0 0 1.327-1.48L12.878 4Zm2.726 0h-1.833l.682 6.123c.062.564.536.989 1.105.989h.56a1.11 1.11 0 0 0 1.071-1.409L15.605 4Zm2.95.528a.89.89 0 0 0-.81-.528h-1.216l.72 2.59 1.029 3.708c.133.478.573.814 1.07.814h.38c.375 0 .74-.168.954-.474a1.09 1.09 0 0 0 .107-1.089l-2.232-5.021Z"
    />
  </svg>
);
export default SvgStore;
